import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/api/admin';

export const adminKeys = {
  me: ['admin', 'me'] as const,
  overview: ['admin', 'overview'] as const,
};

export function useAdminMe(enabled: boolean = true) {
  return useQuery({
    queryKey: adminKeys.me,
    queryFn: () => adminApi.me(),
    staleTime: 60_000,
    retry: false,
    enabled,
  });
}

export function useAdminOverview(enabled: boolean = true) {
  return useQuery({
    queryKey: adminKeys.overview,
    queryFn: () => adminApi.overview(),
    refetchInterval: 60_000,
    enabled,
  });
}
